import React from 'react';
import Header from './layout/header-nav';
import Sidebar from './layout/sidebar';
import Footer from './layout/footer';
import CmRouter, { links } from './routes';
import Dispatcher from './common/dispatcher';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import LoginActions from './login/LoginActions';
import { messageAlert } from './common/components/confirm';
import UIStore from './common/UIStore';
import { NewsModal } from './news/components/NewsModal';
export default withRouter(class App extends React.PureComponent<RouteComponentProps> {
  componentDidMount() {
    Dispatcher.register(async (action: any) => {
      if (action.actionType < 0) {
        if (action.data.status === 401) {

          const info = await LoginActions.getAccountInfo();
          if (!info) {
            this.props.history.push({
              pathname: links.login,
              search: "?returnUrl=" + encodeURIComponent(window.location.href)
            });
          }
          else {
            alert("Utente non autorizzato");
          }
        } else {
          console.error(action);
          if (action.data?.message == "NetworkError when attempting to fetch resource.")
            return;
          await messageAlert(<div className="alert alert-danger text-center" role="alert" style={{ fontSize: "1.2em" }}>
            <div className="mb-2"><i className="far fa-5x fa-frown" /></div>
            <div>Si è verificato un errore imprevisto. Se l'errore persiste contattare l'assistenza!</div>
            {action.data?.message ? <div><small> {JSON.stringify(action.data?.message)} </small></div> : null}
          </div>, "Errore")
        }
      }
    });

    let latestCheck = "";
    const checkVersion = async () => {
      const response = await fetch(process.env.PUBLIC_URL + "/__version.txt", { cache: "no-store" });
      const text = (await response.text())?.trim();
      const currentVersion = require("../package.json").version;
      if (text && text != latestCheck && text != currentVersion) {
        latestCheck = text;
        if (await confirm(`E' presente una nuova versione (${text}) dell'applicazione. Aggiornare?`)) {
          window.location.reload();
        }
      }
    }
    checkVersion();
    setInterval(checkVersion, 600000);
  }
  render() {
    return (
      <>
        <Header />
        <Sidebar />
        <NewsModal />
        <div className="page-wrapper" onClick={() => UIStore.closeSidebarIfNecessary()}>
          <div className="container-fluid">
            <CmRouter />
          </div>
        </div>
        <Footer />
      </ >
    );
  }
});
